import React from 'react';

const StatCard = ({ icon: Icon, title, value, subtitle, gradientFrom, gradientTo }) => {
  return (
    <div className="group bg-white/90 backdrop-blur-xl rounded-3xl p-6 border border-pink-200 shadow-xl hover:shadow-2xl hover:scale-102 transition-all duration-300 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-indigo-50/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      <div className="relative z-10">
        <div className="flex items-center justify-between mb-3">
          <div className={`p-2 bg-gradient-to-br ${gradientFrom} ${gradientTo} rounded-xl shadow-lg group-hover:scale-105 transition-transform`}>
            <Icon className="w-6 h-6 text-white" />
          </div>
          <span className="text-sm text-gray-500 font-medium">{title}</span>
        </div>
        <div className="text-3xl font-bold text-gray-900 mb-0.5">{value}</div>
        <div className="text-xs text-gray-500">{subtitle}</div>
      </div>
    </div>
  );
};

export default StatCard;
